
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[cid]",
      function () {
        return require("private-next-pages/live/[cid]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[cid]"])
      });
    }
  